// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconNumber5 = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M12 4a8 8 0 100 16 8 8 0 000-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12"
    />,
    <path d="M15.5 13.682c0-1.988-1.274-3.388-3.178-3.388-.728 0-1.386.238-1.792.574l.294-2.408h4.004V6.948H9.452l-.602 5.474 1.582.224c.252-.504.784-.896 1.554-.896 1.134 0 1.792.882 1.792 1.988 0 1.176-.658 2.03-1.82 2.03-1.022 0-1.596-.644-1.736-1.512l-1.722.056c.182 1.708 1.512 2.884 3.486 2.884 2.1 0 3.514-1.484 3.514-3.514" />
  );
export default SvgIconNumber5;
